import styled from 'styled-components';
import { Panel, themeUtils as tu, cssMixins } from '@zen-common/components-base';
import { contentXPadding } from '../modules/contentXPadding';

const { resetButton } = cssMixins;
const { color, space } = tu;
const colorByActive = (activeColor, inactiveColor) => p =>
  p.active ? color(activeColor)(p) : color(inactiveColor)(p);

export const StyledContentPanel = styled(Panel)`
  padding: ${space('smd')};
  ${contentXPadding}

  ${tu.mq({
    flexGrow: ['initial', null, '1'],
  })}
`;

export const StyledTab = styled.button`
  ${resetButton}
  background-color: ${color('bg2')};
  padding: ${space('smd')};
  ${contentXPadding}
  width: 50%;
  text-align: left;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  transition: all 0.2s ease;
  &:hover {
    background-color: ${color('bg3')};
  }

  /* BUY */
  &:first-child {
    border-bottom: 1px solid ${colorByActive('success', 'borderDark')};
    h1 {
      color:  ${colorByActive('success', 'label')};
    }
  }
  /* SELL */
  &:last-child {
    border-bottom: 1px solid ${colorByActive('danger', 'borderDark')};
    h1 {
      color:  ${colorByActive('danger', 'label')};
    }
  }
`;
